import { Check } from 'lucide-react';
import { useEffect, useRef, useState, type ReactNode } from 'react';

/** A label that gets shorter on narrow screens (the accessible name stays the long one). */
function Label({ long, short }: { long: string; short?: string | undefined }) {
  if (!short) return <span>{long}</span>;
  return (
    <>
      <span className="label-long">{long}</span>
      <span className="label-short" aria-hidden="true">
        {short}
      </span>
    </>
  );
}

export function CopyButton({
  label,
  shortLabel,
  icon,
  onCopy,
}: {
  label: string;
  shortLabel?: string;
  icon: ReactNode;
  onCopy: () => Promise<boolean>;
}) {
  const [state, setState] = useState<'idle' | 'copied' | 'failed'>('idle');
  const timer = useRef(0);
  useEffect(() => () => window.clearTimeout(timer.current), []);
  return (
    <button
      type="button"
      className={`btn btn--secondary btn--sm${state === 'copied' ? ' is-success' : ''}`}
      aria-label={state === 'idle' ? label : undefined}
      onClick={async () => {
        const ok = await onCopy();
        setState(ok ? 'copied' : 'failed');
        window.clearTimeout(timer.current);
        timer.current = window.setTimeout(() => setState('idle'), 2000);
      }}
    >
      {state === 'copied' ? <Check size={17} aria-hidden="true" /> : icon}
      {state === 'idle' ? (
        <Label long={label} short={shortLabel} />
      ) : (
        <span role="status">{state === 'copied' ? 'Kopiert' : 'Nicht möglich'}</span>
      )}
    </button>
  );
}
